import { render, staticRenderFns } from "./loginPop.vue?vue&type=template&id=2d2fb0e4&scoped=true&"
import script from "./loginPop.vue?vue&type=script&lang=js&"
export * from "./loginPop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d2fb0e4",
  null
  
)

export default component.exports